import React from 'react';
import {motion} from 'framer-motion';
import HeaderLogo from '../HeaderLogo';
import AssociationLogos from '../AssociationLogos';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiAlertCircle}=FiIcons;

export const TEXT_SHADOW='[text-shadow:_0_1px_4px_rgba(0,0,0,0.6)]';

// Marco común de las pantallas de acceso (login y registro).
export default function AuthLayout({subtitle,children,footer,wide=false}) {
  return (
    <div className="min-h-[80vh] flex flex-col items-center justify-center gap-10 px-6 py-10">
      <motion.div
        initial={{opacity: 0,y: 20}}
        animate={{opacity: 1,y: 0}}
        className={`glass-card w-full ${wide ? 'max-w-2xl' : 'max-w-md'} rounded-[2.5rem] p-8 md:p-12 relative overflow-hidden`}
      >
        <div className="absolute top-0 right-0 w-32 h-32 bg-red-600/10 blur-3xl rounded-full -mr-16 -mt-16" />
        <div className="text-center mb-10">
          <div className="inline-flex items-center justify-center w-32 h-32 mb-6">
            <HeaderLogo className="h-full w-full" />
          </div>
          <h2 className={`text-3xl font-black uppercase tracking-tighter text-white ${TEXT_SHADOW}`}>Dojang Digital</h2>
          <p className={`text-white/85 text-[10px] font-bold uppercase tracking-[0.3em] mt-2 ${TEXT_SHADOW}`}>{subtitle}</p>
        </div>
        {children}
        {footer && <div className="mt-8 text-center">{footer}</div>}
      </motion.div>

      <div className="flex flex-col items-center gap-6">
        <AssociationLogos />
        <p className={`text-center text-white/85 text-[10px] font-bold uppercase tracking-[0.3em] ${TEXT_SHADOW}`}>
          Una iniciativa del <span className="text-white font-black">Dojang INTEQ</span> · Moo Duk Kwan México
        </p>
      </div>
    </div>
  );
}

// Campo con etiqueta e ícono opcional, con el estilo de las pantallas de acceso.
export function AuthField({label,icon,children}) {
  return (
    <div className="space-y-2">
      <label className={`text-[10px] font-black uppercase tracking-widest text-white ml-4 ${TEXT_SHADOW}`}>{label}</label>
      <div className="relative">
        {icon && <SafeIcon icon={icon} className="absolute left-5 top-1/2 -translate-y-1/2 text-white/80" />}
        {children}
      </div>
    </div>
  );
}

export const authInputClass=(withIcon=true)=>
  `w-full bg-black/30 border border-white/20 rounded-2xl py-4 ${withIcon ? 'pl-12' : 'pl-6'} pr-6 text-sm text-white placeholder:text-white/60 focus:border-red-500 outline-none transition-all`;

export function AuthError({message}) {
  if (!message) return null;
  return (
    <motion.div initial={{opacity: 0}} animate={{opacity: 1}} className="bg-red-500/10 border border-red-500/20 p-4 rounded-2xl flex items-center gap-3 text-red-400 text-xs font-bold uppercase tracking-wider">
      <SafeIcon icon={FiAlertCircle} className="flex-shrink-0" /> {message}
    </motion.div>
  );
}
